import { render, staticRenderFns } from "./ViewHome.vue?vue&type=template&id=97ab36c2"
import script from "./ViewHome.vue?vue&type=script&lang=js"
export * from "./ViewHome.vue?vue&type=script&lang=js"
import style0 from "./ViewHome.vue?vue&type=style&index=0&id=97ab36c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports